import { IAvatar } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";

export enum ImportSteps {
  importDestination = "import-destination",
  uploadFile = "upload-file",
  mapFields = "map-fields",
  stagedData = "staged-data",
}

export enum ImportStepState {
  active = "active",
  inactive = "inactive",
  completed = "completed",
}

export type TeamboxDynamicData = {
  id: string;
  name: string;
  email?: string;
  role?: string;
  displayName?: string;
  color?: string;
  icon?: string;
  avatar?: IAvatar;
};

export enum StagedDataFilterTabs {
  all = "all",
  valid = "valid",
  invalid = "invalid",
}

export type StagedDataListItem = {
  id: string;
  taskName: string;
  descriptionContent: string;
  taskAssignee: string;
  status: string;
  dueDate: string;
  dateCreated: string;
  priority: string;
};

export enum TeamboxFields {
  _id = "_id",
  subTasks = "subTasks",
  type = "type",
  title = "title",
  description = "description",
  assignedTo = "assignedTo",
  status = "status",
  dueDate = "dueDate",
  createdAt = "createdAt",
  priority = "priority",
  tags = "tags",
  timeEstimation = "timeEstimation",
  timeInvested = "timeInvested",
  actionItems = "actionItems",
}

export type TeamboxFieldData = {
  key: TeamboxFields;
  label: string;
};
